<template>
    <div class="content-table-order">
        <table id="table-order">
            <thead>
                <tr>
                    <th style="width: 180px;">{{ lang.bsto_order }}</th>
                    <th style="text-align:left;">{{ lang.bsto_customer_name }}</th>
                    <th style="width: 100px;">{{ lang.bsto_source }}</th>
                    <th style="text-align: right;">{{ lang.bs_tax }} <span v-if="taxGeneral > 0">( {{ taxGeneral }}% )</span></th>
                    <th style="text-align: right;">{{ lang.bs_delivery_fee }}</th>
                    <th style="width: 50px;">{{ lang.bsto_items }}</th>
                    <th style="width: 80px;text-align: right;">{{ lang.bs_subtotal }}</th>
                    <th style="width: 120px;text-align: right;">{{ lang.bs_total }}</th>
                    <th style="width: 100px;">{{ lang.bsto_payment }}</th>
                    <th style="width: 120px;">{{ lang.bs_status }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="order in orders" :key="order.id" :class="['tr', order.order_status]">
                    <td style="width: 180px; text-align: left;">
                        <div style="display: flex; justify-content: space-between;">
                            <span class="badge badge-light">#{{ order.order_num }}</span>
                            <button class="btn btn-light" @click="$emit('orderSelected', order)">{{ lang.bs_edit }}</button>
                        </div>
                        <div>
                            <small>{{ formatDate(order.created_at) }}</small>
                        </div>
                    </td>
                    <td style="text-align:left;">
                        <h4 style="margin:0;">{{ order.customer_name }} {{ order.customer_lastname }}</h4>
                        <div style="font-size: 0.8rem;"><strong>{{ lang.bs_phone }}:</strong> {{ order.customer_phone }}</div>
                        <div style="font-size: 0.8rem;"><strong>{{ lang.bs_email }}:</strong> {{ order.customer_email }}</div>
                    </td>
                    <td style="width:100px">
                        <span class="badge badge-link" style="text-transform: capitalize;">{{ order.order_source }}</span>
                    </td>
                    <td style="width:100px;text-align: right;">{{currency}} {{ ((order.subtotal * taxGeneral) / 100) | formatMoney }}</td>
                    <td style="width:100px;text-align: right;">{{currency}} {{ delivery_fee | formatMoney }}</td>
                    <td style="width:50px">
                        <button class="badge badge-light" @click="openDetails(order)">
                            {{ order.order_items.length }}
                        </button>
                    </td>
                    <td style="width: 120px;text-align: right;">{{currency}} {{ order.subtotal | formatMoney }}</td>
                    <td style="width: 120px;text-align: right;">{{currency}} {{ order.total | formatMoney }}</td>
                    <td style="width:100px">
                        <DropdownMenu :buttonClass="['arrow-down btn-status', order.payment_status]">
                            <template v-slot:button>
                                <span style="text-transform: capitalize;">
                                    {{ order.payment_status === 'in_progress' ? lang.bsto_in_progress : order.payment_status === 'pending' ? lang.bsto_pending : order.payment_status === 'paid' ? lang.bsto_paid : order.payment_status === 'unpaid' ? lang.bsto_unpaid : order.payment_status === 'declined' ? lang.bsto_declined : order.payment_status }}
                                </span>
                            </template>
                            <template v-slot:menu>
                                <ul style="margin: 0; padding: 0; list-style: none" :key="order.id+'-'+closeMenu">
                                    <li v-if="order.payment_status != 'pending'" @click="changeStatusPayOrder(order, 'pending')">
                                        {{ lang.bsto_pending }}
                                    </li>
                                    <li v-if="order.payment_status != 'in_progress'" @click="changeStatusPayOrder(order, 'in_progress')">
                                        {{ lang.bsto_in_progress }}
                                    </li>
                                    <li v-if="order.payment_status != 'paid'" @click="changeStatusPayOrder(order, 'paid')">
                                        {{ lang.bsto_paid }}
                                    </li>
                                    <li v-if="order.payment_status != 'unpaid'" @click="changeStatusPayOrder(order, 'unpaid')">
                                        {{ lang.bsto_unpaid }}
                                    </li>
                                    <li v-if="order.payment_status != 'declined'" @click="changeStatusPayOrder(order, 'declined')">
                                        {{ lang.bsto_declined }}
                                    </li>
                                </ul>
                            </template>
                        </DropdownMenu>
                    </td>
                    <td style="width:130px">
                        <DropdownMenu :buttonClass="['arrow-down btn-status', order.order_status]">
                            <template v-slot:button>
                                <span style="text-transform: capitalize;">
                                    {{ order.order_status === 'in_transit' ?
                                        lang.bsto_in_transit : order.order_status === 'out_for_delivery' ?
                                            lang.bsto_out_for_delivery : order.order_status === 'ready_for_pickup' ?
                                                lang.bsto_ready_for_pickup : order.order_status === 'picked_up' ?
                                                    lang.bsto_picked_up : order.order_status }}
                                </span>
                            </template>
                            <template v-slot:menu>
                                <ul style="margin: 0; padding: 0; list-style: none" :key="order.id+'-'+closeMenu">
                                    <li v-if="order.order_status != 'pending'" @click="changeStatus(order, 'pending')">
                                        {{ lang.bsto_pending }}
                                    </li>
                                    <li v-if="order.order_status != 'processing'" @click="changeStatus(order, 'processing')">
                                        {{ lang.bsto_processing }}
                                    </li>
                                    <li v-if="order.order_status != 'shipped'" @click="changeStatus(order, 'shipped')">
                                        {{ lang.bsto_shipped }}
                                    </li>
                                    <li v-if="order.order_status != 'in_transit'" @click="changeStatus(order, 'in_transit')">
                                        {{ lang.bsto_in_transit }}
                                    </li>
                                    <li v-if="order.order_status != 'out_for_delivery'" @click="changeStatus(order, 'out_for_delivery')">
                                        {{ lang.bsto_out_for_delivery }}
                                    </li>
                                    <li v-if="order.order_status != 'ready_for_pickup'" @click="changeStatus(order, 'ready_for_pickup')">
                                        {{ lang.bsto_ready_for_pickup }}
                                    </li>
                                    <li v-if="order.order_status != 'delivered'" @click="changeStatus(order, 'delivered')">
                                        {{ lang.bsto_delivered }}
                                    </li>
                                    <li v-if="order.order_status != 'picked_up'" @click="changeStatus(order, 'picked_up')">
                                        {{ lang.bsto_picked_up }}
                                    </li>
                                    <li v-if="order.order_status != 'cancelled'" @click="changeStatus(order, 'cancelled')">
                                        {{ lang.bsto_cancelled }}
                                    </li>
                                </ul>
                            </template>
                        </DropdownMenu>
                    </td>
                </tr>
            </tbody>
        </table>
        <modal name="order-details" :width="400" height="auto" :resizable="true" :adaptive="true" :scrollable="true" before-close="orderDetails = null">
            <div class="card">
                <div class="card-header" style="display:flex; justify-content: space-between; align-items: center;">
                    <h5>{{ lang.bsto_order_details }}</h5>
                    <button class="btn btn-light" @click="$modal.hide('order-details')">
                        <i class="fas fa-times" style="font-size: 24px;cursor: pointer;"></i>
                    </button>
                </div>
                <div class="card-body" style="padding:0px 15px;" v-if="orderDetails">
                    <h3 class="badge badge-primary">{{ orderDetails.order_num }}</h3>
                    <ul class="order_items">
                        <li v-for="(item, index) in orderDetails.order_items" :key="index">
                            <div class="product_name">
                                <strong class="name">{{ item.product_name }}</strong>
                                <!-- <span class="desc">{{ item.product.product_desc }}</span> -->
                                <span class="price_unit">{{ currency }} {{ item.price | formatMoney }}</span>
                            </div>
                            <div class="qty">{{ item.quantity }}</div>
                            <div class="total">{{ currency }} {{ item.total | formatMoney }}</div>
                        </li>
                    </ul>
                </div>
            </div>
        </modal>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import DropdownMenu from '@/core/components/DropdownMenu.vue'
import "./tableOrders.scss";
import ClickOutside from 'vue-click-outside';
export default {
    directives: {
        ClickOutside,
    },
    components: {
        DropdownMenu,
    },
    data(){
        return {
            lang: {
                bsto_order: '',
                bsto_customer_name: '',
                bsto_source: '',
                bs_tax: '',
                bs_delivery_fee: '',
                bsto_items: '',
                bs_subtotal: '',
                bs_total: '',
                bsto_payment: '',
                bs_status: '',
                bs_edit: '',
                bs_phone: '',
                bs_email: '',
                bsto_in_progress: '',
                bsto_pending: '',
                bsto_paid: '',
                bsto_unpaid: '',
                bsto_declined: '',
                bsto_in_transit: '',
                bsto_out_for_delivery: '',
                bsto_ready_for_pickup: '',
                bsto_picked_up: '',
                bsto_processing: '',
                bsto_shipped: '',
                bsto_delivered: '',
                bsto_cancelled: '',
                bsto_order_details: '',
            },
            orders: [],
            apis: null, // to store API endpoints
            taxGeneral: 0,
            delivery_fee: 0,
            closeMenu: 0,
            orderDetails: null,
             refreshKey: 0, // Key to trigger re-render when orders data changes
        };
    },
    computed: {
        ...mapGetters("ModApps/Marketea/", {
            currency: "get_bStore_currency",
            langGetter: "lang",
        }),
    },
    mounted(){
        this.lang = this.$store.getters['ModApps/Marketea/lang'];
        // Fetch API endpoints from parent component or global config
        if(this.$parent && this.$parent.apis){
            this.apis = this.$parent.apis;
        }
        // Optionally, fetch orders from API when component is mounted
        this.fetchOrders();
    },
    methods: {
        fetchOrders(){
            // Example of fetching orders from an API
            let formData = {};
            formData.user_id = window.master_client;
            formData.org_id = window.localorgdata;
            formData.pusher_id = (typeof pusher !== 'undefined' && pusher && pusher.connection)? pusher.connection.socket_id : null;
            const urlService = this.apis ? this.apis.get(3) : null; // getOrders
            // @ts-ignore
            window.master.post(urlService, formData)
                .then(response => {
                    console.log('Orders fetched successfully:', response);
                    if(response && response.data){
                        this.orders = response.data.list; // Assuming the API returns orders in this format
                        this.taxGeneral = response.data.info.tax_enabled && response.data.info.tax_percent > 0 ? response.data.info.tax_percent : 0; // Assuming tax_general is returned in the response
                        this.delivery_fee = response.data.info.delivery_enabled && response.data.info.delivery_fee > 0 ? response.data.info.delivery_fee : 0; // Assuming delivery_fee is returned in the response
                    }
                })
                .catch(error => {
                    console.error('Error fetching orders:', error);
                });
        },
        formatDate(dateString) {
            return new Date(dateString).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit'});
        },
        changeStatusPayOrder(order, newStatus) {
            let formData = {};
            formData.user_id = window.master_client;
            formData.org_id = window.localorgdata;
            formData.pusher_id = (typeof pusher !== 'undefined' && pusher && pusher.connection)? pusher.connection.socket_id : null;
            formData.order_id = order.id;
            formData.payment_status    = newStatus;
            order.payment_status = newStatus; // Update the status locally for immediate UI feedback
            this.closeMenu++; // Trigger menu close by changing the key
            const urlService = this.apis ? this.apis.set(13) : null; // changeStatusPayOrder
            // @ts-ignore
            window.master.post(urlService, formData)
        },
        changeStatus(order, newStatus) {
            let formData = {};
            formData.user_id = window.master_client;
            formData.org_id = window.localorgdata;
            formData.pusher_id = (typeof pusher !== 'undefined' && pusher && pusher.connection)? pusher.connection.socket_id : null;
            formData.order_id = order.id;
            formData.order_status    = newStatus;
            order.order_status = newStatus; // Update the status locally for immediate UI feedback
            this.closeMenu++; // Trigger menu close by changing the key
            const urlService = this.apis ? this.apis.set(12) : null; // changeStatusOrder
            // @ts-ignore
            window.master.post(urlService, formData)
        },
        openDetails(order) {
            this.orderDetails = order; // Set the order details to be displayed in the modal
            this.$modal.show('order-details'); // Show the modal
        },
    },
    watch: {
        langGetter() {
            this.lang = this.$store.getters['ModApps/Marketea/lang'];
        },
        // Watch for changes in orders data if needed
        refreshKey() {
            this.fetchOrders(); // re-fetch orders when refreshKey changes
             // You could perform additional actions here when orders change
        },
    },
}
</script>
<style lang="scss" scoped>
ul.order_items {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
}

ul.order_items li {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 10px;
}

ul.order_items li .product_name {
    width: 200px;
    display: flex;
    flex-direction: column;
}
ul.order_items li span.price_unit {
    font-size: 0.8rem;
}
ul.order_items li .qty {
    border: 1px solid #ddd;
    padding: 2px 9px;
    border-radius: 4px;
    position: relative;
}

ul.order_items li .qty:before {
    content: "X";
    font-size: 0.5rem;
    margin-right: 2px;
}

ul.order_items li .total {
    font-weight: bold;
}


</style>